/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Beta_BadgeInputs */



/**
* | output |
* | --- |
* | "Beta" |
*
* @param {Embed_Captions_Beta_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_beta_badge = /** @type {((inputs?: Embed_Captions_Beta_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Beta_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bêta")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Beta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Бета")
	if (locale === "es") return /** @type {LocalizedString} */ ("Beta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Beta")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ベータ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बीटा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Beta")
	return /** @type {LocalizedString} */ ("Beta")
});